import { render, staticRenderFns } from "./NotaExplicativa.vue?vue&type=template&id=bdbb4ae4&scoped=true"
import script from "./NotaExplicativa.vue?vue&type=script&lang=js"
export * from "./NotaExplicativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbb4ae4",
  null
  
)

export default component.exports